import { render, staticRenderFns } from "./TeachingManagement.vue?vue&type=template&id=661ec1c2&scoped=true"
import script from "./TeachingManagement.vue?vue&type=script&lang=js"
export * from "./TeachingManagement.vue?vue&type=script&lang=js"
import style0 from "./TeachingManagement.vue?vue&type=style&index=0&id=661ec1c2&prod&scoped=true&lang=scss"
import style1 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661ec1c2",
  null
  
)

export default component.exports